import { render, staticRenderFns } from "./MailboxSettings.vue?vue&type=template&id=27ffebec&scoped=true"
import script from "./MailboxSettings.vue?vue&type=script&lang=js"
export * from "./MailboxSettings.vue?vue&type=script&lang=js"
import style0 from "./MailboxSettings.vue?vue&type=style&index=0&id=27ffebec&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "27ffebec",
  null
  
)

export default component.exports